const mode = {
  embedded: 'embedded',
  standalone: 'standalone',
};

export default mode;
